// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Ve9m","inner":"Form_inner__3VSk7","range":"Form_range__1pqQN","name":"Form_name__xTFMy","actions":"Form_actions__22hWs"};